import { j as m } from "../../_virtual/jsx-runtime.js";
import { c } from "../../_virtual/compiler-runtime.js";
import { cn as n } from "../../utils/cn.js";
const a = (i) => {
  const e = c.c(9);
  let l, o;
  e[0] !== i ? ({
    className: l,
    ...o
  } = i, e[0] = i, e[1] = l, e[2] = o) : (l = e[1], o = e[2]);
  let r;
  e[3] !== l ? (r = n("inline-block", l), e[3] = l, e[4] = r) : r = e[4];
  let s;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m.jsx("path", { d: "M6.79491 10.1807C7.18432 10.6065 7.81568 10.6064 8.20509 10.1807L11.2942 6.80291C11.7339 6.32211 11.4225 5.5 10.8006 5.5L4.1994 5.5C3.57755 5.5 3.26612 6.32211 3.70584 6.80291L6.79491 10.1807Z" }), e[5] = s) : s = e[5];
  let t;
  return e[6] !== o || e[7] !== r ? (t = /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: r, ...o, children: s }), e[6] = o, e[7] = r, e[8] = t) : t = e[8], t;
};
a.displayName = "SmallDownArrowIcon";
export {
  a as SmallDownArrowIcon
};
